import { SimpleGrid, Stack, useText } from "@sveabank/cc-common";
import { UspListItem } from "../../../components/bullet-list/usp-list-item";
import Hide from "../../../components/hide";
import type { GrowPackage } from "../../../types/package";
import PackageBlock from "./package-block";

type Props = {
	growPackage: GrowPackage;
};

const GrowPackageBlock = ({ growPackage }: Props) => {
	const [t, texts] = useText();
	const text = texts.choosePackage[growPackage.packageId];

	return (
		<PackageBlock
			heading={t(text.title)}
			headingColor="text-text-contrast"
			onboardingPackage={growPackage}
			bgColor="bg-background-brand-primary"
			imageSrc="GROW"
		>
			<Hide to="tablet">
				<Stack component="ul" gap={4}>
					<SimpleGrid cols={2} gap={1}>
						<UspListItem text={t(text.desktop.bullet1)} />
						<UspListItem text={t(text.desktop.bullet2)} />
						<UspListItem text={t(text.desktop.bullet3)} />
						<UspListItem text={t(text.desktop.bullet4)} />
						<UspListItem text={t(text.desktop.bullet5)} />
						<UspListItem text={t(text.desktop.bullet6)} />
					</SimpleGrid>
				</Stack>
			</Hide>

			<Hide from="tablet">
				<Stack component="ul" gap={4}>
					<SimpleGrid cols={2} gap={1}>
						<UspListItem text={t(text.mobile.bullet1)} />
						<UspListItem text={t(text.mobile.bullet2)} />
						<UspListItem text={t(text.mobile.bullet3)} />
					</SimpleGrid>
				</Stack>
			</Hide>
		</PackageBlock>
	);
};

export default GrowPackageBlock;
